import { subscribeToClubParser } from '@oresundsbron/validators';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { ClubSubscribe } from '../../../components/Forms/ClubSubscribe';
import { validate } from '../../../lib/zod';
import { SignUpFormPart } from '../utils';

export const NewsSubscription: FC<SignUpFormPart> = ({
  namespace,
  titleTranslationKey,
  ns,
}) => {
  const { t } = useTranslation(ns, {
    nsMode: 'fallback',
  });

  return (
    <ClubSubscribe
      namespace={namespace}
      title={t(titleTranslationKey)}
      labels={{
        subscribe: t('form.labels.newsSubscription'),
        loading: t('action.loading'),
      }}
      description={t('form.sections.newsSubscription.description')}
      onValidate={validate(subscribeToClubParser.spa)}
      helpText={t('form.sections.newsSubscription.helpText')}
    />
  );
};
